import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { CircularProgress, Container } from '@mui/material';
import logo from '../Fxer.AI (7).png'; // Adjust the path to your image

const SubscriptionSuccessfulPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    ReactGA.event({
      category: 'User',
      action: 'subscription_success',
      label: 'Subscription Successful',
    });

    // Redirect to the homepage after a delay
    const timer = setTimeout(() => {
      navigate('/'); // Redirect to the user's dashboard or home page
    }, 1000); // Redirect after 2 seconds

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container component="main" maxWidth="sm" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 8 }}>
      <h1>Subscription Successful!</h1>
      <img src={logo} alt="FxerFox" style={{ width: '150px', marginBottom: '20px' }} />
      <p>Welcome to Fxer.AI! You will be redirected to your dashboard shortly.</p>
      <CircularProgress sx={{ mt: 2 }} />
    </Container>
  );
};

export default SubscriptionSuccessfulPage;
